// extracted by mini-css-extract-plugin
export default {"hero":"GigInternet_hero__S-2vc"};